export interface AllFiltersResponse {
  default: {
    key: string
    name: string
    description: string
    criteria: {
      active: boolean
      index: boolean
      mf: boolean
      etf: boolean
      fof: boolean
      not_fof: boolean
    }
  }
  filters: string[]
}

export interface FiltersSetAPIResponse {
  filterId: string
  criteria: {
    includeMutualFund: boolean
    includeETF: boolean
    includeActive: boolean
    includeIndex: boolean
  }
}

export interface FiltersQueryParams {
  mf: boolean
  etf: boolean
  active: boolean
  index: boolean
  fof: boolean
  not_fof: boolean
}

export namespace Filter {
  export type Type = {
    key: string
    name: string
    description: string
    active: boolean
    index: boolean
    mf: boolean
    etf: boolean
    fof: boolean
    not_fof: boolean
  }

  export const NONE = {
    key: "flt_none",
    name: "No filters",
    description:
      "Includes active and index OE long-term MFs and ETFs. Excludes MM funds.",
  }

  export const DEFAULT = {
    key: "flt_Xr7P",
    name: "All except Fund of Funds",
    description: "All MF & ETF, ex FoF",
  }

  export enum KEYS {
    MF = "mf",
    ETF = "etf",
    ACTIVE = "active",
    INDEX = "index",
    FOF = "fof",
    NOT_FOF = "not_fof",
  }

  export const pairDependencies: Record<
    keyof FiltersQueryParams,
    keyof FiltersQueryParams
  > = {
    mf: Filter.KEYS.ETF,
    etf: Filter.KEYS.MF,
    active: Filter.KEYS.INDEX,
    index: Filter.KEYS.ACTIVE,
    fof: Filter.KEYS.NOT_FOF,
    not_fof: Filter.KEYS.FOF,
  }
}
